<template>
  <div
    class="modal fade"
    :id="modalId"
    tabindex="-1"
    role="dialog"
    :aria-labelledby="`${modalId}Label`"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" :id="`${modalId}Label`">
            {{ title }}
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p><strong>{{ message }}</strong></p>
          <p v-if="details" class="text-muted mb-0">{{ details }}</p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            :class="`btn btn-${variant}`"
            data-dismiss="modal"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WarningModal',
  props: {
    modalId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: 'Warning'
    },
    message: {
      type: String,
      required: true
    },
    details: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: 'OK'
    },
    variant: {
      type: String,
      default: 'warning',
      validator: (value) => ['primary', 'info', 'warning', 'danger', 'secondary'].includes(value)
    }
  }
};
</script>